/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import RoomEvent from '../../event/RoomEvent'
import { RoomState } from '../state/RoomState'

class RoomStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new RoomState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case RoomEvent.fetchOne:
        return new RoomState().mergeRoom(payload.room)

      case RoomEvent.onCreate:
        return state.clear()

      case RoomEvent.onEdit:
        return state.set(payload.name, payload.value)

      case RoomEvent.onEditChannelManager:
        if (payload.value === false) {
          return state.merge({ beds24_api_key: '', beds24_prop_key: '', beds24_roomid: '' })
        }
        return state

      default:
        return state
    }
  }
}

export default new RoomStore()
